<form>
  <div class="ps-large-y">
    <h2>{{ 'MMB.apis.form.passport.title' | finLocalization }}</h2>

    <fcom-notification
      class="ps-medium-t"
      [theme]="NotificationTheme.INFO"
      [linkUrl]="'#'"
      [linkText]="'MMB.apis.form.passport.guide.linkText' | finLocalization"
      (linkClick)="showGuide()"
    >
      {{ 'MMB.apis.form.passport.notification' | finLocalization }}
    </fcom-notification>
  </div>

  <div class="ps-small-b font-body-1 nordic-blue-900-text align-right">
    {{ 'MMB.apis.form.passport.mandatoryFields' | finLocalization }}
  </div>

  <div class="flex flex--wrap">
    <fcom-text-input
      class="flex-1 input-field"
      data-testid="passport-lastname"
      [translationPrefix]="'MMB.apis.form.passport.lastName'"
      [parentForm]="passportForm"
      [controlName]="'lastName'"
      [displayMargin]="false"
    ></fcom-text-input>

    <fcom-text-input
      class="flex-1 input-field"
      data-testid="passport-firstname"
      [translationPrefix]="'MMB.apis.form.passport.firstName'"
      [parentForm]="passportForm"
      [controlName]="'firstName'"
      [displayMargin]="false"
    ></fcom-text-input>
  </div>

  <div class="flex flex--wrap">
    <fin-datepicker
      class="flex-1 input-field"
      [translationPrefix]="'MMB.apis.form.passport.birthDate'"
      [parentForm]="passportForm"
      [controlName]="'birthDate'"
      [placeHolder]="'MMB.apis.form.passport.birthDate.placeholder'"
      [icon]="SvgLibraryIcon.CALENDAR"
      [minDate]="LocalDate.forDate(1900, 1, 1)"
      [theme]="DatepickerTheme.WEB_2"
      [displayMargin]="false"
    ></fin-datepicker>

    <fin-select-input
      class="flex-1 input-field"
      [translationPrefix]="'MMB.apis.form.gender'"
      [parentForm]="passportForm"
      [controlName]="'gender'"
      [options]="genders$ | async"
      [displayMargin]="false"
    >
    </fin-select-input>
  </div>

  <div class="flex flex--wrap">
    <fcom-text-input
      class="flex-1 input-field"
      data-testid="passport-number"
      [translationPrefix]="'MMB.apis.form.passport.number'"
      [parentForm]="passportForm"
      [controlName]="'number'"
      [displayMargin]="false"
    >
    </fcom-text-input>

    <fin-select-input
      class="flex-1 input-field"
      [translationPrefix]="'MMB.apis.form.nationality'"
      [parentForm]="passportForm"
      [controlName]="'nationality'"
      [options]="nationalities$ | async"
      [displayMargin]="false"
    >
    </fin-select-input>
  </div>

  <div class="flex flex--wrap" [class.ps-large-b]="!passportForm.controls.issuanceDate">
    <fin-select-input
      class="flex-1 input-field"
      [controlName]="'issuingCountry'"
      [translationPrefix]="'MMB.apis.form.passport.issuingCountry'"
      [parentForm]="passportForm"
      [options]="countries$ | async"
      [displayMargin]="false"
    >
    </fin-select-input>

    <fin-datepicker
      class="flex-1 input-field"
      [parentForm]="passportForm"
      [controlName]="'expiryDate'"
      [placeHolder]="'MMB.apis.form.passport.expiryDate.placeholder'"
      [translationPrefix]="'MMB.apis.form.passport.expiryDate'"
      [icon]="SvgLibraryIcon.CALENDAR"
      [theme]="DatepickerTheme.WEB_2"
      [minDate]="LocalDate.now()"
      [maxDate]="LocalDate.now().plusYears(20)"
      [displayMargin]="false"
    ></fin-datepicker>
  </div>

  <div *ngIf="passportForm.controls.issuanceDate" class="flex flex--wrap ps-large-b">
    <fin-datepicker
      class="flex-1 input-field"
      [parentForm]="passportForm"
      [controlName]="'issuanceDate'"
      [placeHolder]="'MMB.apis.form.passport.issuanceDate.placeholder'"
      [translationPrefix]="'MMB.apis.form.passport.issuanceDate'"
      [icon]="SvgLibraryIcon.CALENDAR"
      [theme]="DatepickerTheme.WEB_2"
      [minDate]="LocalDate.now().minusYears(20)"
      [maxDate]="LocalDate.now()"
      [displayMargin]="false"
    ></fin-datepicker>

    <div class="flex-1 input-field"></div>
  </div>

  <div role="presentation" class="border-top-dashed nordic-blue-100-border fill"></div>

  <div class="ps-large-y flex flex--end">
    <fcom-button
      [type]="ButtonType.SUBMIT"
      [loading]="loading"
      (clickBtn)="saveAndContinue()"
      [text]="'MMB.apis.form.buttons.confirmSave' | finLocalization"
    ></fcom-button>
  </div>
</form>

<fcom-modal
  *ngIf="guide$ | async as guide"
  [open]="guideModalOpen"
  [fitToContent]="true"
  [title]="guide.teaserTitle"
  (close)="guideModalOpen = false"
>
  <div class="pr-medium">
    <fin-content-image [imageData$]="guide$ | finMap: 'picture'" [scale]="false"></fin-content-image>
    <cms-unstyled-fragment
      class="font-body-1 bold-type"
      [showTitle]="false"
      [cmsContent$]="guide$"
    ></cms-unstyled-fragment>
  </div>
</fcom-modal>
